import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Heading from '../shared/Heading';
import MainButton from '../shared/MainButton';

export default class AllDone extends Component {
  componentDidMount() {
    const { firstStepValid, history } = this.props;
    if (!firstStepValid) history.push('/upload');
  }

  render() {
    const { history } = this.props;

    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Heading style={{ marginBottom: 50 }}>All done! Pending admin approval.</Heading>
        <MainButton
          style={{
            width: 700, height: 50, backgroundColor: 'white', color: '#7392ee', marginBottom: 20,
          }}
          onClick={() => {
            history.push('/upload');
          }}
        >
          UPLOAD ANOTHER AD
        </MainButton>
        <MainButton
          style={{
            width: 700, height: 50, backgroundColor: '#7392ee', color: 'white',
          }}
          onClick={() => {
            history.push('/');
          }}
        >
          GO TO MY DASHBOARD
        </MainButton>
      </div>
    );
  }
}

AllDone.propTypes = {
  firstStepValid: PropTypes.bool.isRequired,
  history: PropTypes.objectOf({
    push: PropTypes.func.isRequired,
  }).isRequired,
};



// WEBPACK FOOTER //
// ./client/Upload/AllDone.js